import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { Tag, Empty, Badge, Collapse, Button } from "antd";
import {
  FilterOutlined,
  RightOutlined,
  ArrowLeftOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import ModalItem from "./ModalItem";
import ButtonItem from "./ButtonItem";

const TIPO_DATO_LABEL = {
  numero: "Número",
  texto: "Texto",
  fecha: "Fecha",
  booleano: "Booleano",
};

const BIWO_CYAN = "#00BFD6";
const BIWO_CYAN_LIGHT = "#E6F9FC";
const BIWO_CYAN_DARK = "#008FA0";

const formatearValorLabel = (valor, tipoDato, unidad) => {
  if (tipoDato === "booleano") return valor ? "Sí" : "No";
  if (tipoDato === "fecha") {
    const m = moment(valor);
    return m.isValid() ? m.format("DD/MM/YYYY") : String(valor);
  }
  let label = String(valor);
  if (tipoDato === "numero" && unidad) label = `${label} ${unidad}`;
  return label;
};

class FiltroCategoriasInsumosItem extends Component {
  state = {
    modalFiltrosOpen: false,
    categoriasFiltro: [],
    valoresPorCategoriaFiltro: {},
    categoriaSeleccionada: null,
    loadingCategoriasFiltro: false,
    loadingValoresFiltro: false,
  };

  abrirModalFiltros = () => {
    this.setState({ modalFiltrosOpen: true, categoriaSeleccionada: null });
    if (this.state.categoriasFiltro.length === 0) {
      this.cargarCategoriasFiltro();
    }
  };

  cerrarModalFiltros = () => {
    this.setState({ modalFiltrosOpen: false, categoriaSeleccionada: null });
  };

  cargarCategoriasFiltro = async () => {
    this.setState({ loadingCategoriasFiltro: true });
    try {
      const res = await axios.post(
        "categoriasInsumo/selectTodasCategoriasInsumo",
        {
          empresaId: this.props.empresaId,
          familiaId: "todas",
          valor: 1,
        },
        { headers: this.props.headersToken }
      );
      if (res.data && res.data.success === 2) {
        this.setState({ categoriasFiltro: res.data.categorias || [] });
      } else {
        this.setState({ categoriasFiltro: [] });
      }
    } catch (err) {
      console.error("Error cargando categorías:", err);
      this.setState({ categoriasFiltro: [] });
    } finally {
      this.setState({ loadingCategoriasFiltro: false });
    }
  };

  cargarValoresFiltro = async (categoria) => {
    this.setState({ categoriaSeleccionada: categoria });
    if (this.state.valoresPorCategoriaFiltro[categoria._id]) return;
    this.setState({ loadingValoresFiltro: true });
    try {
      const res = await axios.post(
        "valoresCategoriaInsumo/selectValoresPorCategoria",
        { categoriaInsumoId: categoria._id, valor: 1 },
        { headers: this.props.headersToken }
      );
      if (res.data && res.data.success === 2) {
        this.setState((prev) => ({
          valoresPorCategoriaFiltro: {
            ...prev.valoresPorCategoriaFiltro,
            [categoria._id]: res.data.valores || [],
          },
        }));
      }
    } catch (err) {
      console.error("Error cargando valores:", err);
    } finally {
      this.setState({ loadingValoresFiltro: false });
    }
  };

  emitirCambio = (nuevosFiltros) => {
    if (this.props.onChange) this.props.onChange(nuevosFiltros);
  };

  agregarFiltro = (categoria, valor) => {
    const filtros = this.props.filtros || [];
    const yaExiste = filtros.some((f) => f.categoriaId === categoria._id);
    let nuevos;
    if (yaExiste) {
      nuevos = filtros.map((f) =>
        f.categoriaId === categoria._id
          ? {
              ...f,
              valorId: valor._id,
              valorLabel: formatearValorLabel(
                valor.valor,
                categoria.tipoDato,
                valor.unidad
              ),
            }
          : f
      );
    } else {
      nuevos = [
        ...filtros,
        {
          categoriaId: categoria._id,
          categoriaNombre: categoria.nombre,
          valorId: valor._id,
          valorLabel: formatearValorLabel(
            valor.valor,
            categoria.tipoDato,
            valor.unidad
          ),
          tipoDato: categoria.tipoDato,
        },
      ];
    }
    this.setState({ categoriaSeleccionada: null });
    this.emitirCambio(nuevos);
  };

  quitarFiltro = (categoriaId) => {
    const filtros = this.props.filtros || [];
    this.emitirCambio(filtros.filter((f) => f.categoriaId !== categoriaId));
  };

  limpiarFiltros = () => {
    this.emitirCambio([]);
  };

  renderCategoriaItem(cat) {
    return (
      <div
        key={cat._id}
        className="filtro-item"
        onClick={() => this.cargarValoresFiltro(cat)}
      >
        <div>
          <div style={{ fontWeight: 500 }}>{cat.nombre}</div>
          {cat.descripcion ? (
            <div style={{ fontSize: 11, color: "#888" }}>
              {cat.descripcion}
            </div>
          ) : null}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span className="filtro-meta">
            {TIPO_DATO_LABEL[cat.tipoDato] || cat.tipoDato}
          </span>
          <RightOutlined style={{ color: "#bbb", fontSize: 12 }} />
        </div>
      </div>
    );
  }

  renderModalFiltros() {
    const {
      modalFiltrosOpen,
      categoriasFiltro,
      categoriaSeleccionada,
      valoresPorCategoriaFiltro,
      loadingCategoriasFiltro,
      loadingValoresFiltro,
    } = this.state;
    const filtros = this.props.filtros || [];

    const valores = categoriaSeleccionada
      ? (valoresPorCategoriaFiltro[categoriaSeleccionada._id] || []).filter(
          (v) => v.estado === 1
        )
      : [];

    return (
      <ModalItem
        title="Filtrar insumos por categorías"
        visible={modalFiltrosOpen}
        spinning={loadingCategoriasFiltro || loadingValoresFiltro}
        onCancel={this.cerrarModalFiltros}
        paddingTop
        width={520}
        footer={false}
      >
        <style>{`
          .filtro-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            padding: 9px 12px;
            margin-bottom: 5px;
            border-radius: 6px;
            cursor: pointer;
            transition: background-color 0.15s ease, color 0.15s ease;
            border: 1px solid #eee;
            background: #fff;
            font-size: 13px;
            user-select: none;
          }
          .filtro-item:hover {
            background: ${BIWO_CYAN_LIGHT};
            border-color: ${BIWO_CYAN};
            color: ${BIWO_CYAN_DARK};
          }
          .filtro-meta {
            font-size: 11px;
            color: #888;
            background: #f5f5f5;
            padding: 1px 7px;
            border-radius: 8px;
          }
        `}</style>

        {filtros.length > 0 && (
          <div
            style={{
              marginBottom: 14,
              padding: "8px 10px",
              background: BIWO_CYAN_LIGHT,
              border: `1px solid ${BIWO_CYAN}`,
              borderRadius: 6,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 6,
              }}
            >
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  color: BIWO_CYAN_DARK,
                  letterSpacing: "0.4px",
                  textTransform: "uppercase",
                }}
              >
                Filtros activos
              </span>
              <Button
                type="link"
                size="small"
                onClick={this.limpiarFiltros}
                style={{ fontSize: 11, color: BIWO_CYAN_DARK, padding: 0, height: "auto" }}
              >
                Quitar todos
              </Button>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {filtros.map((f) => (
                <Tag
                  key={f.categoriaId}
                  closable
                  onClose={(e) => {
                    e.preventDefault();
                    this.quitarFiltro(f.categoriaId);
                  }}
                  color="cyan"
                  style={{ margin: 0 }}
                >
                  <strong>{f.categoriaNombre}:</strong> {f.valorLabel}
                </Tag>
              ))}
            </div>
          </div>
        )}

        {!categoriaSeleccionada ? (
          <>
            <div
              style={{
                fontSize: 11,
                fontWeight: 600,
                color: "#6b7280",
                letterSpacing: "0.4px",
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              1. Selecciona una categoría
            </div>
            {categoriasFiltro.length === 0 && !loadingCategoriasFiltro ? (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No hay categorías configuradas"
              />
            ) : (
              <div style={{ maxHeight: "55vh", overflowY: "auto" }}>
                {(() => {
                  const principales = categoriasFiltro.filter((c) => c.esPrincipal);
                  const hijasConPadre = [];
                  const sueltas = [];
                  categoriasFiltro
                    .filter((c) => !c.esPrincipal)
                    .forEach((c) => {
                      const padreId = c.categoriaPadreId ? c.categoriaPadreId.toString() : null;
                      if (
                        padreId &&
                        principales.some((p) => p._id.toString() === padreId)
                      ) {
                        hijasConPadre.push(c);
                      } else {
                        sueltas.push(c);
                      }
                    });
                  const hijasOf = (p) =>
                    hijasConPadre.filter(
                      (c) =>
                        c.categoriaPadreId &&
                        c.categoriaPadreId.toString() === p._id.toString()
                    );

                  return (
                    <>
                      {principales.length > 0 && (
                        <>
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: 600,
                              color: BIWO_CYAN_DARK,
                              letterSpacing: "0.4px",
                              textTransform: "uppercase",
                              margin: "4px 0 6px 2px",
                            }}
                          >
                            Categorías agrupadas
                          </div>
                          <Collapse
                            ghost
                            defaultActiveKey={principales.map((p) =>
                              p._id.toString()
                            )}
                            className="filtro-collapse"
                          >
                            {principales.map((p) => {
                              const sus = hijasOf(p);
                              return (
                                <Collapse.Panel
                                  key={p._id.toString()}
                                  header={
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 6,
                                        fontWeight: 600,
                                      }}
                                    >
                                      <FolderOpenOutlined
                                        style={{ color: BIWO_CYAN }}
                                      />
                                      {p.nombre}
                                      <span
                                        style={{
                                          fontSize: 11,
                                          color: "#888",
                                          fontWeight: 400,
                                          marginLeft: 4,
                                        }}
                                      >
                                        {sus.length === 0
                                          ? "(sin hijas)"
                                          : `(${sus.length})`}
                                      </span>
                                    </span>
                                  }
                                >
                                  {sus.length === 0 ? (
                                    <div
                                      style={{
                                        fontSize: 12,
                                        color: "#999",
                                        paddingLeft: 8,
                                      }}
                                    >
                                      Esta categoría principal no tiene hijas aún.
                                    </div>
                                  ) : (
                                    sus.map((cat) => this.renderCategoriaItem(cat))
                                  )}
                                </Collapse.Panel>
                              );
                            })}
                          </Collapse>
                        </>
                      )}
                      {sueltas.length > 0 && (
                        <>
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: 600,
                              color: "#6b7280",
                              letterSpacing: "0.4px",
                              textTransform: "uppercase",
                              margin:
                                principales.length > 0
                                  ? "14px 0 6px 2px"
                                  : "4px 0 6px 2px",
                            }}
                          >
                            Otros campos
                          </div>
                          {sueltas.map((cat) => this.renderCategoriaItem(cat))}
                        </>
                      )}
                    </>
                  );
                })()}
              </div>
            )}
          </>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginBottom: 10,
              }}
            >
              <Button
                type="link"
                size="small"
                onClick={() => this.setState({ categoriaSeleccionada: null })}
                style={{ color: BIWO_CYAN_DARK, padding: 0, height: "auto" }}
              >
                <ArrowLeftOutlined /> Categorías
              </Button>
            </div>
            <div
              style={{
                fontSize: 11,
                fontWeight: 600,
                color: "#6b7280",
                letterSpacing: "0.4px",
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              2. Selecciona un valor de "{categoriaSeleccionada.nombre}"
            </div>
            {valores.length === 0 && !loadingValoresFiltro ? (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Esta categoría no tiene valores"
              />
            ) : (
              <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                {valores.map((v) => {
                  const label = formatearValorLabel(
                    v.valor,
                    categoriaSeleccionada.tipoDato,
                    v.unidad
                  );
                  return (
                    <div
                      key={v._id}
                      className="filtro-item"
                      onClick={() =>
                        this.agregarFiltro(categoriaSeleccionada, v)
                      }
                    >
                      <span style={{ fontWeight: 500 }}>{label}</span>
                      <span style={{ color: BIWO_CYAN_DARK, fontSize: 12 }}>
                        Seleccionar
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </ModalItem>
    );
  }

  render() {
    const { disabled, buttonStyle, buttonProps } = this.props;
    const filtros = this.props.filtros || [];
    const numFiltros = filtros.length;

    return (
      <>
        <Badge
          count={numFiltros}
          size="small"
          offset={[-4, 4]}
          style={{ backgroundColor: BIWO_CYAN, boxShadow: "none" }}
        >
          <ButtonItem
            type={numFiltros > 0 ? "primary" : "default"}
            icon={<FilterOutlined />}
            onClick={this.abrirModalFiltros}
            disabled={disabled}
            style={{
              ...(numFiltros > 0
                ? { background: BIWO_CYAN, borderColor: BIWO_CYAN }
                : {}),
              ...buttonStyle,
            }}
            tooltip="Filtrar por categorías"
            {...buttonProps}
          />
        </Badge>
        {this.renderModalFiltros()}
      </>
    );
  }
}

export { formatearValorLabel };
export default FiltroCategoriasInsumosItem;
